// Action Types
export const REFETCH_ON = "VEHICLE_MANAGE/REFETCH_ON" as const;
export const REFETCH_OFF = "VEHICLE_MANAGE/REFETCH_OFF" as const;
// 뒤에 as const 를 붙여줌으로써 나중에 액션 객체를 만들게 action.type 의 값을 추론하는 과정에서
// action.type 이 string 으로 추론되지 않고 'AUTH/LOGIN' 와 같이 실제 문자열 값으로 추론되도록 해줍니다.
